export const nl = {
  ErrorTextOnGetDataOnSubmitError:
    "Er is een fout opgetreden tijdens ophalen informatie. Probeer het later opnieuw.",
  ErrorGeboorteDatumInfoOphalen:
    "Er is een fout opgetreden tijdens ophalen informatie obv geboortedatum. Probeer het later opnieuw.",
  ErrorPartnerGeboorteDatumInfoOphalen:
    "Er is een fout opgetreden tijdens ophalen informatie obv geboortedatum partner. Probeer het later opnieuw.",
  FoutTijdensUitvoerenBerekening: "Fout tijdens uitvoeren berekening. Probeer het later opnieuw.",
  FoutTijdensBepalenHebLeb: "Fout tijdens bepalen eigenbijdrage berekening. Probeer het later opnieuw.",
  FoutTijdensBerekenPeilJaarVerlegging: "Fout tijdens uitvoeren berekening. Probeer het later opnieuw.",
  BijdrageType: "Soort eigen bijdrage",
  BijdrageTypeHebOfLeb: "Betaalt u de 'lage eigen bijdrage' of de 'hoge eigen bijdrage'?",
  BriefBeschikkingInfo: "Dit staat in de brief over uw eigen bijdrage (beschikking).",
  BriefBeschikkingBerekeningInfo:
    "Dit staat in de brief over uw eigen bijdrage (beschikking), in de berekening.",
  DateNotInFutureValidationFactoryText:
    "U heeft in het invulveld '{{label}}' geen juiste datum ingevuld. Deze mag niet in de toekomst liggen.",
  DeVeldenMetEenzijnVerplicht: "De velden met een * zijn verplicht.",
  DownloadPDF: "Download PDF",
  ErrorPeiljaarInfoOphalen:
    "Fout tijdens ophalen info ten behoeve van uitvoeren 'rekenhulp aanpassing eigen-bijdrage'",
  ZorgjarenOphalenFailed: "Fout tijdens ophalen beschikbare zorgjaren.",
  GemeentenOphalenFailed: "Fout tijdens ophalen gemeenten informatie.",
  WatIsUwGeboorteDatum: "Wat is uw geboortedatum?",
  GeboorteDatumPartner: "Geboortedatum partner (dd-mm-jjjj)",
  GeboorteDatumVanPartner: "Geboortedatum partner",
  GeboorteDatumPartnerLabel: "Geboortedatum van uw partner (dd-mm-jjjj)",
  WatIsDeGeboorteDatumVanUwPartnerLabel: "Wat is de geboortedatum van uw partner?",
  HogeEigenBijdrageInkomsten: "Uw inkomen en vermogen",
  HEBOpgelegdeEigenBijdrage: "Wat is de eigen bijdrage die u per maand moet betalen in {{zorgjaar}}?",
  HEBInkomen: "Wat {{is_was}} uw inkomen uit werk en woning (box 1) in {{zorgjaar}}?",
  HEBAanmerkelijkBelang: "Wat {{is_was}} uw inkomen uit aanmerkelijk belang (box 2) in {{zorgjaar}}?",
  HEBSpaargeld:
    "Hoeveel geld stond er op 1 januari {{zorgjaar}} op uw betaal- en spaarrekening(en) (box 3)? ",
  HEBEigenVermogen: "Hoeveel ander vermogen (box 3) had u op 1 januari {{zorgjaar}}?",
  HEBLoonheffing: "Wat {{is_was}} uw inkomstenbelasting in {{zorgjaar}}?",

  HogeEigenBijdrageInkomstenPartner: "Inkomen en vermogen van uw partner",
  HEBOpgelegdeEigenBijdragePartner: "Wat is de eigen bijdrage die uw partner moet betalen in {{zorgjaar}}?",
  HEBInkomenPartner: "Wat {{is_was}} het inkomen uit werk en woning (box 1) van uw partner in {{zorgjaar}}?",
  HEBAanmerkelijkBelangPartner:
    "Wat {{is_was}} het inkomen uit aanmerkelijk belang (box 2) van uw partner in {{zorgjaar}}?",
  HEBSpaargeldPartner:
    "Hoeveel geld stond er op 1 januari {{zorgjaar}} op de betaal- en spaarrekening(en) (box 3) van uw partner?",
  HEBEigenVermogenPartner: "Hoeveel ander vermogen (box 3) had uw partner op 1 januari {{zorgjaar}}?",
  HEBLoonheffingPartner: "Wat {{is_was}} de inkomstenbelasting van uw partner in {{zorgjaar}}?",

  HEBAanmerkelijkBelangInfo:
    "Als u dit heeft, dan staat dit op uw (voorlopige) belastingaanslag. Heeft u geen inkomen uit aanmerkelijk belang? Vul dan 0 in. ",
  HEBAanmerkelijkBelangPartnerInfo:
    "Als uw partner dit heeft, dan staat dit op de (voorlopige) belastingaanslag. Heeft uw partner geen inkomen uit aanmerkelijk belang? Vul dan 0 in.",
  HEBInkomenInfo:
    "Neem uw (verwachte) bruto jaarinkomen (bruto maandinkomen x 12). Dit kan zijn: salaris, pensioen en uitkering. Tel het vakantiegeld erbij op. Hypotheekrente en/of giften mag u eraf halen.",
  HEBInkomenPartnerInfo:
    "Neem het (verwachte) bruto jaarinkomen van uw partner (bruto maandinkomen x 12). Dit kan zijn: salaris, pensioen en uitkering. Tel het vakantiegeld erbij op. Hypotheekrente en/of giften mag u eraf halen.",
  HEBSpaargeldInfo: "Stond er geen geld op een rekening? Vul dan 0 in. ",
  HEBSpaargeldPartnerInfo: "Stond er geen geld op een rekening? Vul dan 0 in. ",
  HEBVermogenInfo:
    "Ander vermogen is bijvoorbeeld de waarde van beleggingen of een tweede woning. Had u geen ander vermogen? Vul dan 0 in. ",
  HEBVermogenPartnerInfo:
    "Ander vermogen is bijvoorbeeld de waarde van beleggingen of een tweede woning. Had uw partner geen ander vermogen? Vul dan 0 in.",
  HEBLoonheffingInfo:
    "Neem uw (verwachte) loonheffing per jaar (loonheffing per maand x 12). Dit staat op uw loonstrook of maandspecificatie. Tel de loonheffing vakantiegeld erbij op. De belastingteruggave hypotheekrente en/of giften mag u eraf halen.",
  HEBLoonheffingPartnerInfo:
    "Neem de (verwachte) loonheffing per jaar van uw partner (loonheffing per maand x 12). Dit staat op de loonstrook of maandspecificatie. Tel de loonheffing vakantiegeld erbij op. De belastingteruggave hypotheekrente en/of giften mag u eraf halen.",
  Partner: "Partner",
  Heeftueenpartner: "Heeft u een partner?",
  HogeEigenBijdrage: "Hoge eigen bijdrage",
  HoogteLageEigenBijdrage: "Laagste eigen bijdrage?",
  HoogteLageEigenBijdrageLabel:
    "Betaalt u {{vasteBijdrageMptEnPgb}} per maand voor een modulair pakket thuis of een persoonsgebonden budget? Of betaalt u {{minimaleLageEigenBijdrage}} per maand voor zorg in een instelling of een volledig pakket thuis?",
  IsRequiredValidationFactoryValidationText: "U heeft het invulveld '{{label}}' niet ingevuld.",
  IsBedragValidationFactoryValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld.",
  DateValidationFactoryValidationText: "U heeft in het invulveld '{{label}}' geen juiste datum ingevuld.",
  Ja: "Ja",
  KlikHierOmOpnieuwTeBeginnen: "Klik hier om opnieuw te beginnen",
  LageEigenBijdrage: "Lage eigen bijdrage",
  LageEigenBijdrageInkomsten: "Uw inkomen en vermogen",
  LEBInkomen: "Wat {{is_was}} uw inkomen uit werk en woning (box 1) in {{zorgjaar}}?",
  LEBAanmerkelijkBelang: "Wat {{is_was}} uw inkomen uit aanmerkelijk belang (box 2) in {{zorgjaar}}?",
  LEBSpaargeld:
    "Hoeveel geld stond er op 1 januari {{zorgjaar}} op uw betaal- en spaarrekening(en) (box 3)? ",
  LEBEigenVermogen: "Hoeveel ander vermogen (box 3) had u op 1 januari {{zorgjaar}}?",
  LageEigenBijdrageInkomstenPartner: "Inkomen en vermogen van uw partner",
  LEBInkomenPartner: "Wat {{is_was}} het inkomen uit werk en woning (box 1) van uw partner in {{zorgjaar}}?",
  LEBAanmerkelijkBelangPartner:
    "Wat {{is_was}} het inkomen uit aanmerkelijk belang (box 2) van uw partner in {{zorgjaar}}?",
  LEBSpaargeldPartner:
    "Hoeveel geld stond er op 1 januari {{zorgjaar}} op de betaal- en spaarrekening(en) (box 3) van uw partner?",
  LEBEigenVermogenPartner: "Hoeveel ander vermogen (box 3) had uw partner op 1 januari {{zorgjaar}}?",
  LEBInkomenInfo:
    "Neem uw (verwachte) bruto jaarinkomen (bruto maandinkomen x 12). Dit kan zijn: salaris, pensioen en uitkering. Tel het vakantiegeld erbij op. Hypotheekrente en/of giften mag u eraf halen.",
  LEBInkomenPartnerInfo:
    "Neem het (verwachte) bruto jaarinkomen van uw partner (bruto maandinkomen x 12). Dit kan zijn: salaris, pensioen en uitkering. Tel het vakantiegeld erbij op. Hypotheekrente en/of giften mag u eraf halen.",
  LEBAanmerkelijkBelangInfo:
    "Als u dit heeft, dan staat dit op uw (voorlopige) belastingaanslag. Heeft u geen inkomen uit aanmerkelijk belang? Vul dan 0 in.",
  LEBAanmerkelijkBelangPartnerInfo:
    "Als uw partner dit heeft, dan staat dit op de (voorlopige) belastingaanslag. Heeft uw partner geen inkomen uit aanmerkelijk belang? Vul dan 0 in.",
  LEBSpaargeldInfo: "Stond er geen geld op een rekening? Vul dan 0 in. ",
  LEBVermogenInfo:
    "Ander vermogen is bijvoorbeeld de waarde van beleggingen of een tweede woning. Had u geen ander vermogen? Vul dan 0 in. ",
  LEBSpaargeldPartnerInfo: "Stond er geen geld op een rekening? Vul dan 0 in. ",
  LEBVermogenPartnerInfo:
    "Ander vermogen is bijvoorbeeld de waarde van beleggingen of een tweede woning. Had uw partner geen ander vermogen? Vul dan 0 in.",
  LageEigenBijdrageBijdragePlichtigInkomen: "Uw inkomen en vermogen",
  LEBBijdragePlichtigInkomen:
    "Met welk bijdrageplichtig inkomen (op jaarbasis) hebben wij uw eigen bijdrage voor {{peiljaarBijdrageplichtigInkomen}} berekend?",
  LetOp: "Let op",
  Nee: "Nee",
  U: "U",
  UwPartner: "Uw partner",
  UwGeboorteDatum: "Uw geboortedatum",
  OverzichtLageEigenBijdrage: "Laatste check",
  OverzichtHogeEigenBijdrage: "Laatste check",
  GeboorteDatum: "Geboortedatum (dd-mm-jjjj)",
  GeboortedatumLabel: "Geboortedatum",
  GeenRechtenOntlenenAanUitkomst: "u kunt geen rechten ontlenen aan de uitkomst van de rekenhulp.",
  GeenRechtenOntlenenProefberekening:
    "u kunt geen rechten ontlenen aan de uitkomst van deze proefberekening. 100% zekerheid krijgt u pas als u de aanpassing hebt aangevraagd.",
  Volgende: "Volgende",
  Vorige: "Vorige",
  Voorwelkjaar: "Jaar",
  Voorwelkjaarvraagtueenaanpassingaan: "Voor welk jaar vraagt u een aanpassing aan?",
  PJVToolAlgemeneToelichting:
    "Met deze rekenhulp berekent u of u een aanpassing van de eigen bijdrage kunt aanvragen.",
  PJVToolResultLEBAanpassen: `De uitkomst van deze proefberekening is: wij kunnen de eigen bijdrage mogelijk voor u aanpassen. Uw (bijdrageplichtig) inkomen is sinds {{peiljaar}} namelijk gedaald met {{bedrag}} of meer. Dat is de voorwaarde voor een aanpassing van de lage eigen bijdrage.`,
  PJVToolResultVraagEenAanpassingAan: `Vraag een aanpassing aan`,
  PJVToolResultLEBNietAanpassen: `De uitkomst van deze proefberekening is: wij kunnen de eigen bijdrage mogelijk niet voor u aanpassen. Uw (bijdrageplichtig) inkomen is sinds {{peiljaar}} namelijk niet gedaald met {{bedrag}} of meer. Dat is de voorwaarde voor een aanpassing van de lage eigen bijdrage.`,
  PJVToolResultLEBAanpassingVoorwaarden: `Bekijk de voorwaarden voor een aanpassing van de lage eigen bijdrage`,
  PJVToolResultHEBAanpassen: `De uitkomst van deze proefberekening is: wij kunnen de eigen bijdrage mogelijk voor u aanpassen. U houdt per maand namelijk minder geld over dan de zak- en kleedgeldgrens van {{bedrag}}. Dat is de voorwaarde voor een aanpassing van de hoge eigen bijdrage.`,
  PJVToolResultHEBAanpassingVoorwaarden: `Bekijk de voorwaarden voor een aanpassing van de hoge eigen bijdrage`,
  PJVToolResultHEBNietAanpassen: `De uitkomst van deze proefberekening is: wij kunnen de eigen bijdrage mogelijk niet voor u aanpassen. U houdt per maand namelijk niet minder geld over dan de zak- en kleedgeldgrens van {{bedrag}}. Dat is de voorwaarde voor een aanpassing van de hoge eigen bijdrage.`,
  ProefBerekeningGemaakt: "Er is een proefberekening gemaakt met de gegevens die u hebt ingevoerd.",
  StapCategorieZorgGegevens: "Uw zorg",
  StapCategoriePersoonsGegevens: "Uw gegevens",
  StapCategorieFinancieleGegevens: "Uw inkomen en vermogen",
  StapCategorieGegevens: "Uw gegevens",
  StapCategorieEigenBijdrage: "Uw eigen bijdrage",
  StapCategorieInkomen: "Uw inkomen en vermogen",
  StapCategorieOverzicht: "Laatste check",
  StapCategorieUitkomst: "Uitkomst",
  OverzichtEigenBijdrage: "Overzicht eigen bijdrage",
  RekenhulpAanpassingEigenBijdrage: "Rekenhulp aanpassing eigen bijdrage",
  NietOudGenoegAanpassingEigenBijdrage:
    "U bent {{leeftijdInJaren}} jaar. Dan kunt u helaas geen aanpassing van de eigen bijdrage aanvragen. Wij hebben uw eigen bijdrage namelijk al berekend met het inkomen dat u nu heeft. Dat hebben we opgevraagd bij UWV en omgerekend naar een jaarinkomen.\n\nKloppen de inkomensgegevens op uw beschikking niet? Stuur ons dan een bewijs van het inkomen dat u nu wel heeft. Bijvoorbeeld een maandspecificatie van uw inkomen in dit jaar.",
  OverzichtEigenBijdrageRekenhulp: "Overzicht eigen bijdrage rekenhulp",
  EigenBijdrageRekenhulp: "Rekenhulp Eigen Bijdrage",
  VoorWelkJaarWiltUDeEbBerekenen: "Voor welk jaar wilt u de eigen bijdrage berekenen?",
  HulpOfZorgThuis: "Ik krijg hulp of zorg thuis",
  ZorgInEenInstelling: "Ik woon in een instelling",
  IkKrijgOokZorgInEenInstelling: "Ja, ik krijg ook zorg in een instelling",
  IkKrijgOokEenVolledigPakketThuis: "Ja, ik krijg ook een volledig pakket thuis",
  IkkrijgOokEenModulairPakketThuis: "Ja, ik krijg ook een modulair pakket thuis",
  IkKrijgOokEenPGBVanuitDeWLZ: "Ja, ik krijg ook een Persoonsgebonden Budget vanuit de Wlz",
  WoontThuisZorgAnders: "Ik woon thuis en krijg hulp of zorg ergens anders",
  IkKrijgEenPersoonsgebondenBudget: "Ik krijg een persoonsgebonden budget",
  PersoonsgebondenBudget: "Persoonsgebonden budget",
  KiesDeZorgOfHulp: "Om welke zorg of hulp gaat het?",
  KiesDeZorgOfOndersteuning: "Kies de zorg of ondersteuning",
  ZorgOfOndersteuning: "Zorg of ondersteuning",
  ZorgOfOndersteuningThuis: "Zorg of ondersteuning thuis",
  ZorgOfhulp: "Zorg of hulp",
  OmWelkeZorgOfHulpGaatHet: "Om welke zorg of hulp gaat het?",
  OmWelkeZorgOfOndersteuningThuisGaatHet: "Om welke zorg of ondersteuning thuis gaat het?",
  OmWelkeZorgOfOndersteuningGaatHet: "Om welke zorg of ondersteuning gaat het?",
  OmWatVoorPersoonsgebondenBudgetGaatHet: "Om wat voor persoonsgebonden budget gaat het?",
  OndersteuningVanuitDeWmo: "Ik krijg ondersteuning vanuit de Wmo",
  VolledigPakketThuis: "Ik krijg een volledig pakket thuis",
  ModulairPakketThuis: "Ik krijg een modulair pakket thuis",
  PgbVoorDeWetLangdurigeZorgWlz: "Pgb voor de Wet langdurige zorg (Wlz)",
  PgbVoorDeWetMaatschappelijkeOndersteuningWmo: "Pgb voor de Wet maatschappelijke ondersteuning (Wmo)",
  PgbVoorVerplegingEnVerzorging: "Pgb voor verpleging en verzorging",
  AfEnToeInEenZorginstellingLogeren: "Ik logeer af en toe in een zorg instelling",
  Persoonsgegevens: "Persoonsgegevens",
  WieRegeltUwHulp: "Wie regelt uw hulp?",
  DeGemeenteRegeltHetLogeren: "De gemeente regelt het logeren",
  DeGemeenteRegeltDeDagbesteding: "De gemeente regelt de dagbesteding",
  HetZorgkantoorRegeltHetLogeren: "Het zorgkantoor regelt het logeren",
  HetZorgkantoorRegeltDeDagbesteding: "Het zorgkantoor regelt de dagbesteding",
  IkGaNaarDagbesteding: "Ik ga naar dagbesteding",
  KiesEenOptie: "Kies een optie",
  KiesEenGemeente: "Kies een gemeente",
  GemeenteOfZorgkantoor: "Gemeente of zorgkantoor",
  Uitkomst: "Uitkomst",
  Berekeningen: "Berekeningen",
  BerekeningTonen: "Berekening tonen",
  BerekeningTonenHeb: "Berekening tonen - Hoge Eigen Bijdrage",
  BerekeningTonenLeb: "Berekening tonen - Lage Eigen Bijdrage",
  NeeMijnPartnerKrijgtGeenZorgOfHulp: "Nee, mijn partner krijgt geen zorg of hulp",
  JaMijnPartnerKrijgtHulpVanuitDeWmo: "Ja, mijn partner krijgt hulp vanuit de Wmo",
  JaMijnPartnerWoontInEenZorginstelling: "Ja, mijn partner woont in een zorginstelling",
  JaMijnPartnerHeeftEenVolledigPakketThuis: "Ja, mijn partner heeft een volledig pakket thuis",
  JaMijnPartnerHeeftEenModulairPakketThuis: "Ja, mijn partner heeft een modulair pakket thuis",
  JaMijnPartnerHeeftEenPgbVanuitDeWlz: "Ja, mijn partner heeft een Persoonsgebonden Budget vanuit de Wlz",
  KrijgtUwPartnerOokZorgOfHulp: "Krijgt uw partner ook zorg of hulp?",
  ZorgOfHulpPartner: "Zorg of hulp partner",
  HeeftUKostenVoorUwKinderen: "Heeft u kosten voor uw kind?",
  KostenVoorUwKinderen: "Kosten voor uw kind(eren)?",
  Kind: "Kind",
  AndereZorg: "Andere zorg",
  OntvangtUNogAndereZorg: "Ontvangt u nog andere zorg?",
  Geen: "Nee, ik krijg geen verdere zorg",
  Gemeente: "Gemeente",
  InWelkeGemeenteWoontU: "In welke gemeente woont u?",
  FinanciëleGegevens: "Financiële gegevens",
  WatWasUwInkomenIn: "Wat {{is_was}} uw inkomen in {{jaar}}?",
  WatWasInkomenPartnerIn: "Wat {{is_was}} het inkomen van uw partner in {{jaar}}?",
  WatWasUwGrondslagSparenEnBeleggenIn:
    "Wat {{is_was}} uw grondslag sparen en beleggen op 1 januari {{jaar}}?",
  WatWasUwEigenVermogenIn: "Wat {{is_was}} uw vermogen (spaargeld of beleggingen) op 1 januari {{jaar}}?",
  WatWasGrondslagSparenEnBeleggenPartnerIn:
    "Wat {{is_was}} de grondslag sparen en beleggen van uw partner op 1 januari {{jaar}}?",
  HoeveelInkomstenBelastingBetaaldIn:
    "Hoeveel inkomstenbelasting of loonheffing heeft u in {{jaar}} betaald?",
  HoeveelInkomstenBelastingBetaaldInInfo:
    "De inkomstenbelasting staat op uw belastingaanslag. Geen belastingaangifte gedaan? Dan staat de loonheffing op uw jaaropgave(n).",
  HoeveelInkomstenBelastingPartnerBetaaldIn:
    "Hoeveel inkomstenbelasting of loonheffing heeft uw partner in {{jaar}} betaald?",
  HoeveelInkomstenBelastingPartnerBetaaldInInfo:
    "Voor de hoge eigen bijdrage trekken wij de betaalde belasting van het inkomen van uw partner af. U vindt dit bedrag op de belastingaanslag ('inkomstenbelasting en premie volksverzekeringen') of de jaaropgave ('loonheffing').",
  WatWasUwInkomenUitWerkIn: "Wat {{is_was}} uw inkomen uit werk in {{jaar}}?",
  WatWasUwInkomenUitWerkInInfo: "Vul uw totale netto inkomen uit werk of de Ziektewet in.",
  WatWasInkomenUitWerkPartnerIn: "Wat {{is_was}} het inkomen uit werk van uw partner in {{jaar}}?",
  WatWasInkomenUitWerkPartnerInInfo:
    "Had uw partner in {{jaar}} inkomen uit werk of de Ziektewet? Vul dan hier uw totale netto inkomen uit werk of de Ziektewet in.",
  WatWasEigenVermogenPartnerIn:
    "Wat {{is_was}} het vermogen (spaargeld of beleggingen) van uw partner op 1 januari {{jaar}}?",
  PartnerEigenVermpogenInfoText: "Had uw partner geen spaargeld of beleggingen? Vul dan 0 in.",
  WatWasHetBedragAanslagZvwIn: "Wat {{is_was}} het bedrag van uw aanslag Zorgverzekeringswet in {{jaar}}?",
  WatWasHetBedragAanslagZvwInInfo:
    "U ontvangt een aanslag voor de Zorgverkeringswet bijvoorbeeld als u (freelance) ondernemer bent. Of als u alimentatie ontvangt.",
  WatWasHetBedragAanslagZvwVanUwPartnerIn:
    "Wat {{is_was}} het bedrag van de aanslag Zorgverzekeringswet van uw partner in {{jaar}}?",
  WatWasHetBedragAanslagZvwVanUwPartnerInInfo:
    "Uw partner ontvangt een aanslag voor de Zorgverkeringswet bijvoorbeeld als hij of zij (freelance) ondernemer is. Of alimentatie ontvangt. Vul het bedrag van de aanslag in.",
  LetselschadevergoedingIn: "Letselschadevergoeding in {{jaar}}",
  Letselschadevergoeding: "Letselschadevergoeding",
  DeFinanciëleGegevensVanUwPartner: "De financiële gegevens van uw partner",
  GrondslagSparenEnBeleggenInfoText: "Had u geen inkomen uit sparen of beleggen? Vult u dan 0 in.",
  EigenVermogenInfoText: "Had u geen spaargeld of beleggingen? Vul dan 0 in",
  PartnerGrondslagSparenEnBeleggenInfoText:
    "Had uw partner geen inkomen uit sparen en beleggen? Vult u dan 0 in.",
  PGBVerplegingGeenEigenBijdrage:
    "U hoeft voor het persoonsgebonden budget voor verpleging en verzorging geen eigen bijdrage aan het CAK te betalen. Deze zorg wordt vergoed uit het basispakket van uw zorgverzekeraar.",
  KrijgtUOokZorgInEenInstelling:
    "Krijgt u ook zorg in een instelling die u niet hoeft te betalen met uw pgb?",
  KrijgtUOokZorgInEenInstellingToelichting: `Bijvoorbeeld omdat u een deel van uw zorg zelf regelt (inkoopt met een pgb).
 En ook zorg krijgt van een organisatie die afspraken heeft gemaakt met uw gemeente of het zorgkantoor. 
 Wij noemen dat ‘zorg in natura’. Heeft u een combinatie van een pgb en zorg in natura? 
 Dan betaalt u een eigen bijdrage voor wonen in een zorginstelling.`,
  LetselschadevergoedingInfoText: "Heeft u een letselschadevergoeding ontvangen? Vul dan het bedrag in.",
  AowVoorOngehuwden: "AOW voor ongehuwden",
  HeeftUEenAowVoorOngehuwden: "Heeft u een AOW voor ongehuwden?",
  HeeftUwPartnerEenAowVoorOngehuwden: "Heeft uw partner een AOW voor ongehuwden?",
  OverzichtEigenBijdrageBerekening: "Laatste check",
  FinancieleGegevensSubLabelText:
    "Wij berekenen de eigen bijdrage met het verzamelinkomen (inkomen en vermogen) van 2 jaar geleden. Dat krijgen we van de Belastingdienst. Tip: op mijnoverheid.nl kunt u het inkomen zien dat de Belastingdienst voor u heeft geregistreerd.",
  BedragPerMaand: "Bedrag per maand",
  UBetaalt: "U betaalt",
  UwEigenBijdrage: "Uw eigen bijdrage",
  UwPartnerBetaalt: "Uw partner betaalt",
  HasMaxLengthValidationText:
    "U heeft in het invulveld '{{label}}' geen juiste waarde ingevuld. Deze mag niet meer dan {{maxLength}} cijfers bevatten.",
  leesMeerOverLebHebLabel: "Lees meer over de lage en hoge eigen bijdrage",
  bonUwverzamelinkomen: "Uw verzamelinkomen",
  bonUwverzamelinkomenMinBelasting: "Uw verzamelinkomen min de verschuldigde belasting",
  bonTotaalverzamelinkomen: "Totaal verzamelinkomen",
  bonTotaalverzamelinkomenMinBelasting: "Totaal verzamelinkomen min de verschuldigde belasting",
  bonVerzamelinkomenVanUwPartner: "Verzamelinkomen van uw partner",
  bonVerzamelinkomenMinBelastingVanUwPartner: "Verzamelinkomen min de verschuldigde belasting van uw partner",
  bonCompensatieVervallenOuderentoeslag: "Compensatie vervallen ouderentoeslag",
  bonCompensatieVervallenOuderentoeslagPartner: "Compensatie vervallen ouderentoeslag van uw partner",
  bonBerekeningLageEigenBijdrage: "Berekening lage eigen bijdrage",
  bonBerekeningHogeEigenBijdrage: "Berekening hoge eigen bijdrage",
  bonBerekeningMinimabeleid: "Bepaling eigen bijdrage",
  bonBerekeningEigenBijdrage: "Berekening eigen bijdrage",
  bonAftrekBijPGBofMPT: "Aftrek bij pgb of modulair pakket thuis (mpt)",
  bonUwBijdrageplichtigInkomen: "Uw bijdrageplichtig inkomen",
  bonBijtellingVermogenPercentage: "Bijtelling vermogen ({{percentage}}%)",
  bonRendementsgrondslagBovenVrijstelling: "Rendementsgrondslag boven de vrijstelling",
  bonRendementsgrondslagBovenVrijstellingVanUEnPartner:
    "Rendementsgrondslag boven de vrijstelling van u (en uw partner)",
  bonUwGrondslagSparenEnBeleggen: "Uw grondslag sparen en beleggen",
  bonGrondslagSparenEnBeleggennVanUEnPartner: "Grondslag sparen en beleggen van u (en uw partner)",
  bonBerekeningBijtellingVermogen: "Berekening bijtelling vermogen",
  bonMaximaleKortingNietAOWgerechtigdeLeeftijd: `Maximale korting niet-AOW-gerechtigde leeftijd`,
  bonVrijstellingLetselschadevergoeding: `Vrijstelling letselschadevergoeding`,
  bonPercentageVanDitBedrag: `Percentage van dit bedrag`,
  bonBijtellingVermogen: `Bijtelling vermogen`,
  bonEigenbijdragePerJaar: `Eigen bijdrage per jaar`,
  bonBijdragePerMaand: `Bijdrage per maand`,
  bonPgbMptAftrek: `Pgb/mpt-aftrek`,
  bonEigenbijdrageUenUPartnerPerMaand: "De eigen bijdrage van u en uw partner per maand",
  bonEigenbijdragePartnerPerMaand: "De eigen bijdrage van uw partner per maand",
  bonUwEigenbijdragePerMaand: "Uw eigen bijdrage per maand",
  bonEigenbijdragePerMaandZonderMinEnMax: `Eigen bijdrage per maand zonder minimum en maximum`,
  bonMinimabeleidNationaalTarief: "Nationaal tarief",
  bonMinimabeleidGemeentelijkTarief: "Gemeentelijk tarief ({{gemeenteNaam}})",
  bonMinimabeleidValtBovenGrensbedrag: "Valt bijdrageplichtig inkomen boven inkomensgrens?",
  bonMinimabeleidGrensbedrag: "Gemeentelijke inkomensgrens minimabeleid ({{gemeenteNaam}})",
  bonMinimumEigenbijdrage: `Minimum eigen bijdrage`,
  bonMaximumEigenbijdrage: `Maximum eigen bijdrage`,
  ZorgKeuzeHulpOfZorgThuis: "U ontvangt zorg of hulp thuis",
  ZorgKeuzeZorgInEenInstelling: "U ontvangt zorg in een instelling",
  ZorgKeuzeThuisWonen: "U woont thuis, maar u ontvangt ergens anders hulp of zorg",
  ZorgKeuzePersoonsgebondenBudget: "U ontvangt een persoonsgebonden budget",
  ZorgPersoonsgebondenBudgetKeuzePGB_WLZ: "U heeft een pgb voor de Wet langdurige zorg",
  ZorgPersoonsgebondenBudgetKeuzePGB_WMO: "U heeft een pgb voor de Wet maatschappelijke ondersteuning",
  ZorgPersoonsgebondenBudgetKeuzePGB_ZVW: "U heeft een pgb voor verpleging en verzorging",
  ZorgThuisWonenKeuzeDagbesteding: "U gaat naar dagbesteding",
  ZorgThuisWonenKeuzeKortdurend_Verblijf: "U logeert af en toe in een zorginstelling",
  ZorgHulpOfZorgThuisKeuzeHulpmiddelen: "U ontvangt ondersteuning vanuit de Wmo thuis",
  ZorgHulpOfZorgThuisKeuzeModulair_Pakket_Thuis: "U heeft een modulair pakket thuis",
  ZorgHulpOfZorgThuisKeuzeVolledig_Pakket_Thuis: "U heeft een volledig pakket thuis",
  partnerZorgKeuzeGeen_Zorg: "Uw partner ontvangt geen zorg of ondersteuning",
  partnerZorgKeuzeModulair_Pakket_Thuis: "Uw partner heeft een modulair pakket thuis",
  partnerZorgKeuzeOndersteuning_Vanuit_Wmo: "Uw partner ontvangt ondersteuning vanuit de Wmo thuis",
  partnerZorgKeuzePGB_WLZ: "Uw partner heeft een pgb voor de Wlz",
  partnerZorgKeuzeVolledig_Pakket_Thuis: "Uw partner heeft een volledig pakket thuis",
  partnerZorgKeuzeWoont_In_Zorginstelling: "Uw partner woont in een zorginstelling",
  meerInfoMPT: "Meer weten over de berekening van een modulair pakket thuis (mpt)?",
  meerInfoPGB: "Meer weten over de berekening van een persoonsgebonden budget (pgb)?",
  meerInfoWMO: "Meer weten over de Wmo?",
  overigeZorgKeuzeGeen_Overige_Zorg: "U ontvangt geen andere zorg",
  overigeZorgKeuzeModulair_Pakket_Thuis: "U ontvangt ook een modulair pakket thuis",
  overigeZorgKeuzePGB_WLZ: "U ontvangt ook een persoonsgebonden budget voor de Wlz",
  overigeZorgKeuzeVolledig_Pakket_Thuis: "U ontvangt ook een volledig pakket thuis",
  overigeZorgKeuzeWoont_In_Zorginstelling: "U ontvangt ook nog zorg in een instelling",
  uheeftgeenpartner: "U heeft geen partner",
  onderstaandegegevensingevuld: "Voor deze berekening heeft u onderstaande gegevens ingevuld.",
  welkezorgofondersteuningontvangtu: "Welke zorg of ondersteuning ontvangt u?",
  uwpersoonsgegevens: "Uw persoonsgegevens:",
  wwwhetcaknl_berekeninglaag: "www.hetcak.nl/berekening/laag",
  wwwhetcaknl_berekeninghoog: "www.hetcak.nl/berekening/hoog",
  lageofhogeeigenbijdragebetalen: "Moet u een lage of hoge eigen bijdrage betalen?",
  lageofhogeeigenbijdragebetalenToelichting: `Welke eigen bijdrage u betaalt, hangt af van uw situatie. Woont u in een instelling? Dan betaalt u de \
eerste 4 maanden de lage eigen bijdrage voor Wlz-zorg. Daarna betaalt u meestal de hoge eigen \
bijdrage. Er zijn uitzonderingen. Bijvoorbeeld als uw partner nog thuis woont. Of wanneer u voor \
kinderen moet zorgen. Dan blijft u de lage eigen bijdrage betalen. Meer informatie over wanneer u de \
lage of hoge eigen bijdrage moet betalen:`,
  wwwhetcaknl_berekening_laagofhoog: "www.hetcak.nl/berekening/laag-of-hoog",
  uwgeboortedatumis: "Uw geboortedatum is {{geboortedatum}}",
  uwAftrekPremieZorgverzekering: "Uw aftrek premie zorgverzekering",
  aftrekPremieZorgverzekeringVanUwPartner: "Aftrek premie zorgverzekering van uw partner",
  bonTotaalAftrekPremieZorgverzekering: "Totaal aftrek premie zorgverzekering",
  zakEnKleedgeld: "Zak- en kleedgeld",
  aftrekNietAowGerechtigdeLeeftijd: "Aftrek (niet-)AOW-gerechtigde leeftijd",
  bonTotaalPersoonlijkeKosten: "Totaal persoonlijke kosten",
  prctInkomstenUitTegenwoordigeArbeid: "{{percentage}}% van uw inkomsten uit tegenwoordige arbeid",
  prctInkomstenUitTegenwoordigeArbeidPartner:
    "{{percentage}}% van de inkomsten uit tegenwoordige arbeid van uw partner",
  bonTotaleInkomstenUitTegenwoordigeArbeid: "Totale inkomsten uit tegenwoordige arbeid",
  beschikbaarInkomen: "Beschikbaar inkomen",
  aftrekVanHetBeschikbaarInkomen: "Aftrek van het beschikbaar inkomen",
  bonBedragPerMaand: "Bedrag per maand",
  bonMinimaleEigenBijdrage: "Minimale eigen bijdrage",
  bonUwVerzamelinkomenMetAandeel: "Uw verzamelinkomen {{aandeel}}%",
  bonMaximaleEigenBijdrage: "Maximale eigen bijdrage",
  bonVerzamelinkomenVanUwPartnerMetAandeel: "Verzamelinkomen van uw partner {{aandeel}}%",
  bonBerekeningTotaalVerzamelinkomen: "Totaal verzamelinkomen 100%",
  bonBerekeningVerzamelinkomen: "Berekening verzamelinkomen",
  bonBerekeningPremieZorgverzekering: "Berekening premie zorgverzekering",
  bonPremieZorgverzekeringKlant: "Uw aftrek premie zorgverzekering",
  bonPremieZorgverzekeringPartner: "Aftrek premie zorgverzekering van uw partner",
  standaardPremie: "Standaard premie",
  inkomensafhankelijkeBijdrage: "Inkomensafhankelijke bijdrage",
  aanslagZorgverzekeringswet: "Aanslag Zorgverzekeringswet",
  zorgtoeslag: "Zorgtoeslag",
  premieZorgverzekering: "Premie zorgverzekering",
  berekendePremie: "Berekende premie",
  minimumPremie: "Minimum premie",
  maximumPremie: "Maximum premie",
  uiteindelijkePremies: "Premies",
  totalePremie: "Totale premie",
  eerste4MaandenLebKlant: `U betaalt {{aandeelKlant}}%, {{bedragKlant}} voor de eerste 4 maanden`,
  eerste4MaandenLebPartner: `Uw partner betaalt {{aandeelPartner}}%, {{bedragPartner}} voor de eerste 4 maanden`,
  eigenBijdrageUenPartner: "De eigen bijdrage voor u en uw partner is {{eigenBijdrage}} per maand",
  uwEigenbijdrageWmoIs: `Uw eigen bijdrage is {{eigenBijdrage}} per maand`,
  gemeentelijkTariefWmo:
    "Dit bedrag is lager dan de maximale eigen bijdrage. Dit komt omdat de gemeente {{gemeenteNaam}} een lager tarief hanteert.",
  uHoeftGeenEigenbijdrageTeBetalen: "U hoeft geen eigen bijdrage te betalen",
  maxEigenbijdrage:
    "Dit is het bedrag dat u maximaal moet betalen per maand. U betaalt nooit méér dan dit bedrag.",
  uWoonInDeGemeente: `U woont in de gemeente {{gemeenteNaam}}`
};
